import { Link } from "react-router-dom";

const Footer = () => (
    <footer
        data-testid="app-footer"
        className="border-t border-rule mt-24 py-10 bg-parchment"
    >
        <div className="container-edit flex flex-col gap-6">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="font-serif italic text-ink/70">
                    « Un fait surprenant et sourcé chaque matin. À lire, à écouter, à retenir. »
                </p>
                <p className="text-xs uppercase tracking-[0.22em] text-ink/50">
                    © 2026 Le savez-vous ? — édité par 3h33 SARL
                </p>
            </div>
            <nav
                data-testid="footer-legal"
                className="flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.18em] text-ink/50"
            >
                {/* Pages publiques servies par le backend : liens classiques. */}
                <a href="/histoires" data-testid="footer-histoires" className="hover:text-terracotta transition-colors">
                    Les histoires
                </a>
                <a href="/podcast" data-testid="footer-podcast" className="hover:text-terracotta transition-colors">
                    Podcast
                </a>
                <a href="/entreprises" data-testid="footer-entreprises" className="hover:text-terracotta transition-colors">
                    Entreprises
                </a>
                <a href="/annonceurs" data-testid="footer-annonceurs" className="hover:text-terracotta transition-colors">
                    Annonceurs
                </a>
                <a href="/#faq" className="hover:text-terracotta transition-colors">
                    Questions fréquentes
                </a>
                <Link to="/mentions-legales" className="hover:text-terracotta transition-colors">
                    Mentions légales
                </Link>
                <Link to="/confidentialite" className="hover:text-terracotta transition-colors">
                    Confidentialité
                </Link>
                <Link to="/cgu" className="hover:text-terracotta transition-colors">
                    CGU
                </Link>
                {/* Aucune adresse e-mail affichée : le contact passe par un formulaire. */}
                <a href="/contact" data-testid="footer-contact" className="hover:text-terracotta transition-colors">
                    Contact
                </a>
                <a
                    href="https://www.buymeacoffee.com/choucroutecitron"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-support"
                    className="text-terracotta hover:text-ink transition-colors font-semibold"
                >
                    ☕ Soutenir
                </a>
                <a
                    href="https://3h33.com/vibe-coding/"
                    data-testid="footer-fabrique"
                    className="hover:text-terracotta transition-colors"
                >
                    Fabriqué en vibe coding par 3h33
                </a>
            </nav>
        </div>
    </footer>
);

export default Footer;
